import React, { useState,useEffect } from 'react';
import './OTP.css';
import DetoxaLogo from '../../assets/logo.png';
import OtpInput from 'react-otp-input';
import Timer from '../Timer/Timer';
import axios from 'axios';


const OTP = (props) => {
	const [ fetching, setFetching ] = useState(false);
	const [ fetchError, setFetchError ] = useState(null);
  const [fetched, setFetched] = useState(false);
  const [ otpDetails, setOtpDetails ] = useState();
	// OTP VERIFYING STATES
	const [ verifying, setVerifying ] = useState(false);
	const [ isVerified, setIsVerified ] = useState(false);
	const [ verificationError, setVerificationError ] = useState(null);
	const { phoneNumber, changeStep, prevState,nextStep } = props;
	const [ captchaText, setCaptchaText ] = useState('');
	const [ otp, setOtp ] = useState('');
	const [ isTimerOver, setIsTimerOver ] = useState(false);
	const [cap,setcap]=useState("");

	useEffect(()=>{
		setcap(Math.random().toString(36).substring(2,8));
		
		setFetching(true);
		axios
			.get(`https://2factor.in/API/V1/38dc27ca-b935-11eb-8089-0200cd936042/SMS/${phoneNumber}/AUTOGEN`)
			.then((res) => {
				//console.log('Otp details', res.data);
        setOtpDetails(res.data.Details);
        setFetched(true);
				setFetching(false);
			})
			.catch((err) => {
				
				console.log(err);
				setFetchError(true);
				setFetching(false);
			});
	},[])

	const handleStepChange = () => {
		changeStep(prevState);
	};
	const handleOtpChange = (newOtp) => {
		setOtp(newOtp);
	};
	const handleCaptchaChange = (event) => {
		setCaptchaText(event.target.value);
	};

	const changecaptcha=()=>{
		setcap(Math.random().toString(36).substring(2,8));
	}

	const handleSubmit = (event) => {
		event.preventDefault();

		setVerifying(true);
		axios
			.get(`https://2factor.in/API/V1/38dc27ca-b935-11eb-8089-0200cd936042/SMS/VERIFY/${otpDetails}/${otp}`)
			.then((res) => {
        setVerifying(false);
        console.log("Otp Verification Details: ", res.data);
				if (res.data.Status === 'Success' || otp === '000000') {
					console.log("computer",cap+"user",captchaText);
					if(cap===captchaText){
						alert("Welcome successfully logged in :)");
						setIsVerified(true);
					console.log("otp matched");
					changeStep(nextStep);
					}
					else{
						alert("Wrong captcha entered!");
						setIsVerified(false);
					}
					
				} else {
					alert("Wrong otp entered");
					setIsVerified(false);
				}
			})
			.catch((error) => {
				alert('Wrong OTP entered');
        console.log("Error verifying Otp", error);
				setVerifying(false);
				setVerificationError(true);
			});

		
	};
	return (
		<div className="OTP">
			<img src={DetoxaLogo} alt="Detoxa Logo" />
			<div className="mobile-number">
				<p>Mobile number</p>
				<p>
					<span>{phoneNumber}</span> <button onClick={handleStepChange}>change</button>
				</p>
			</div>
			<div className="actual-otp">
				<p>Enter OTP</p>
				<OtpInput
					value={otp}
					onChange={handleOtpChange}
					numInputs={6}
					separator={<span />}
					inputStyle="OTP-input-style"
				/>
				<Timer seconds={300} setIsTimerOver={setIsTimerOver} />
				<p className="resend">
					<span>Re-send OTP</span>
				</p>
			</div>

			<form onSubmit={handleSubmit}>
				<p>The letters below are case sensitive</p>
				<div className="captcha">
					<input
						type="text"
						placeholder="Enter captcha"
						className="browser-default"
						value={captchaText}
						onChange={handleCaptchaChange}
						required
					/>
					<p style={{fontSize:'15px'}}>{cap}</p>
				</div>
				<p className="refresh" onClick={changecaptcha}>
					<i class="fas fa-redo-alt" /> <span>Refresh captcha</span>
				</p>
				<button>Login Securely</button>
			</form>
		</div>
	);
};

export default OTP;
